import '.f{width:100%;}.ssr-plugin'
import '.dd{height:4px;}.ssr-plugin'
import '.a7{position:relative;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.l{gap:12px;}.ssr-plugin'
import '.de{align-items:flex-start;}.ssr-plugin'
import '.ae{align-self:stretch;}.ssr-plugin'
import '.df{border-radius:999px;}.ssr-plugin'
import '.dg{opacity:0.15;}.ssr-plugin'
import '.bc{overflow:hidden;}.ssr-plugin'
import '.dh{transition:width 120ms ease-out;}.ssr-plugin'
import '.an{position:absolute;}.ssr-plugin'
import '.di{left:0px;}.ssr-plugin'
import '.dj{top:0px;}.ssr-plugin'
import '.bl{padding:24px;}.ssr-plugin'
import '.ba{position:fixed;}.ssr-plugin'
import '.aw{bottom:0px;}.ssr-plugin'
import '.dk{right:0px;}.ssr-plugin'
import '.aj{margin:0 auto;}.ssr-plugin'
import '.bj{max-width:1280px;}.ssr-plugin'
import '.ag{justify-content:space-between;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.dl{gap:48px;}.ssr-plugin'
import '.b5{align-items:start;}.ssr-plugin'
import '.ac{flex-direction:column;}.ssr-plugin'
import { FC } from 'react'
import { Text } from './Text'
import { Button } from './Button'
import { useTheme } from '../providers/useTheme'
import { Link } from 'wouter'
import { styled } from 'inlines'
import { useAppCtx } from '../providers/useAppCtx'
import { formatCurrency } from '@/apps/cms/utils/misc'
import { useTranslations } from '../hooks/useTranslations'

type CartItemsIndicatorProps = {
  cartItems?: number
  cartItemsMax?: number
  cartItemsMin?: number
  color?: string
}

export const CartItemsIndicator: FC<CartItemsIndicatorProps> = ({
  cartItems = 0,
  cartItemsMax = 0,
  cartItemsMin = 0,
  color = '#FFFFFF',
}) => {
  const ratio =
    cartItemsMax && cartItemsMax > 0 ? Math.min(cartItems / cartItemsMax, 1) : 0

  const widthMinVotesBar = Math.floor((cartItemsMin / cartItemsMax) * 100)
  const diff = cartItemsMax - cartItemsMin

  const ratioForSecondBar =
    cartItems >= cartItemsMin ? ((cartItems - cartItemsMin) / diff) * 100 : 0

  return cartItemsMin && cartItemsMin > 1 ? (
    <div className="f dd a7 a l"
    >
      {/* minvotes bar */}
      <div className="dd a7"
        style={{
          width: widthMinVotesBar + '%',}}
      >
        <div className="a dd de ae df dg bc"
          style={{
            background: color,}}
        ></div>
        <div className="dd df dh an di dj"
          style={{
            width:
              cartItems < cartItemsMin
                ? `${(cartItems / cartItemsMin) * 100}%`
                : '100%',
            background: color,}}
        />
      </div>

      {/* second bar */}
      <div className="dd a7"
        style={{
          width: `calc(100% - ${widthMinVotesBar}%`,}}
      >
        <div className="a dd de ae df dg bc"
          style={{
            background: color,}}
        ></div>
        <div className="dd df dh an di dj"
          style={{
            width: `${ratioForSecondBar}%`,
            background: color,}}
        />
      </div>
    </div>
  ) : (
    <div className="f dd a7"
    >
      <div className="a dd de ae df dg bc"
        style={{
          background: color,}}
      ></div>
      <div className="dd df dh an di dj"
        style={{
          width: `${ratio * 100}%`,
          background: color,}}
      />
    </div>
  )
}

export const CartBar: FC = () => {
  const { colors } = useTheme()

  const {
    votesCount,
    activeLanguage,
    price,
    currency,
    maxVotes,
    minVotes = 0,
  } = useAppCtx()
  const { data: cartTranslations } = useTranslations('cart')

  const priceLabel = formatCurrency(
    (votesCount * price) / 100,
    currency,
    activeLanguage,
  )

  return (
    <div className="f bl ba aw dk di"
      style={{
        background: colors.primaryAccent,}}
    >
      <div className="aj f bj a ag d dl"
      >
        <div className="f b5 a ac l"
        >
          <CartItemsIndicator
            cartItems={votesCount}
            cartItemsMax={maxVotes}
            cartItemsMin={minVotes}
            color={colors.background}
          />

          <Text variant="display-regular" color={colors.background}>
            {minVotes && votesCount < minVotes
              ? cartTranslations?.minVotes_indicator
              : `${cartTranslations?.counting_votes_indicator} - ${priceLabel}`}
          </Text>
        </div>

        <Link href="/cart">
          <Button
            isDisabled={minVotes ? votesCount < minVotes : false}
            id="cartbar-link-cart"
            label={cartTranslations?.add_to_cart_button}
            trailIcon="arrow"
            style={{ background: colors.background }}
            color={colors.primaryAccent}
          />
        </Link>
      </div>
    </div>
  )
}
